import classNames from 'classnames';
import * as style from './ScrollPanel.module.less';
import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { useStoreUI } from '@assets/model/Store';
import useMeasure from 'react-use-measure';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useReactToScrollButtons } from '@assets/hooks/useReactToScrollButtons';

interface IScrollPanelProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    id?: string;
    enableHideScrollUntilMouseOver?: boolean;
    onLoadScrollToEnd?: boolean;
    disableKeyboardScroll?: boolean;
}

export const ScrollPanel = observer((props: IScrollPanelProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const classes = classNames(style.scrollContainer, props.className);
    const uiStore = useStoreUI();
    const [resizeRef, bounds] = useMeasure();
    const enableHideScrollUntilMouseOver =
        props.enableHideScrollUntilMouseOver === true;
    const disableKeyboardScroll = props.disableKeyboardScroll === true;

    const [firstLoadScroll, setFirstLoadScroll] = useState(false);

    useReactToScrollButtons(
        scrollRef.current,
        uiStore,
        disableKeyboardScroll ? 0 : 100
    );

    useEffect(() => {
        if (enableHideScrollUntilMouseOver) {
            scrollRef.current.style.scrollbarColor = 'transparent transparent';
        }
    }, [scrollRef.current]);

    if (props.onLoadScrollToEnd) {
        if (!firstLoadScroll && scrollRef.current?.scrollHeight > 0) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            setFirstLoadScroll(true);
        }
    }
    return (
        <Flex fillCell={true} style={{ position: 'relative' }}>
            <div
                ref={resizeRef}
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                }}
            ></div>
            <div
                className={classes}
                style={{
                    position: 'absolute',
                    width: bounds.width,
                    height: bounds.height,
                    ...props.style
                }}
                id={props.id}
                ref={scrollRef}
                onMouseLeave={() => {
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor =
                        'transparent transparent';
                }}
                onMouseEnter={() => {
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor =
                        '#eaecf0 transparent';
                }}
            >
                {props.children}
            </div>
        </Flex>
    );
});
